import { render, staticRenderFns } from "./PerformanceGroupDialog.vue?vue&type=template&id=805c72d2&scoped=true&"
import script from "./PerformanceGroupDialog.vue?vue&type=script&lang=js&"
export * from "./PerformanceGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceGroupDialog.vue?vue&type=style&index=0&id=805c72d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805c72d2",
  null
  
)

export default component.exports